export default __webpack_public_path__ + "static/media/reviewLeft.4a544eeb.svg";